import Utils from '@/core/utils/Utils';
import Core from "@/core/Core";

/** заголовки и месяцы для поиска в производственном плане */
const requiredFields = ['Код', 'Наименование', 'Площадка'];

const months         = [
	'Январь', 'Февраль', 'Март', 'Апрель', 'Май', 'Июнь',
	'Июль', 'Август', 'Сентябрь', 'Октябрь', 'Ноябрь', 'Декабрь',
];

/** номера для преобразования даты */
const monthDigits     = [
	'01', '02', '03', '04', '05', '06',
	'07', '08', '09', '10', '11', '12',
];

const ReportHelpers = {
	/** upload и update в данном случае одно и тоже, работает для плана и изменений */
	importDiffs(payload) {
		return new Promise((resolve, reject) => {
			Core.rpc.makeRequest('productionPlans.importDiffs', { diffs: payload }, null, null, true, null, null, false, {timeout: 120000})
				.then(({ data }) => {
					if (data) {
						resolve(data);
					} else {
						reject(new Error('Ошибка сервера'));
					}
				})
				.catch(error => {
					reject(error);
				});
		});
	},

	getDiffs(payload) {
		return new Promise((resolve, reject) => {
			Core.rpc.makeRequest('productionPlans.getDiffs', payload)
				.then(({ data }) => {
					if (Utils.isObject(data)) {
						resolve(data);
					} else {
						reject(new Error('Ошибка сервера'));
					}
				})
				.catch(error => {
					reject(error);
				});
		});
	},

	exportDiffs(responseData) {
		return new Promise((resolve, reject) => {
			Core.rpc.makeRequest('productionPlans.exportDiffs', { diffs: responseData })
				.then(({ data }) => {
					if (data?.data) {
						const blob =  Utils.file.base64ToBlob(
							data.data,
							'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet',
							'Изменения плана'
						);
						Utils.file.downloadBlob(blob);
						resolve();
					} else {
						reject(new Error('Файл не получен'));
					}
				})
				.catch(reject);
		});
	},

};

export {
	ReportHelpers, requiredFields, months, monthDigits,
};
